// extracted by mini-css-extract-plugin
export default {"drawer":"NP6t6P4sOzSaVmzTSzrx","expandIcon":"fuTmQiQgq791MFiMiTfg","accordion":"Z0flLgT42oIz0XgbijkD","panel":"LLKgBUaeHOQFYNv3w7q6","description":"M2BT2J0Cp8POJH9GPNSM"};